export default {
    namespaced: true,
    state: () => ({
        current_link: '',
    }),
    mutations: {
        setCurrentLink(state, current_link) {
            state.current_link = current_link;
        },
    },
    getters: {
        currentLink(state) {
            return state.current_link;
        },
    },
    actions: {
        updateCurrentLink({ commit }, payload) {
            commit('setCurrentLink', payload);
        },
    },
};
